module.exports = __webpack_public_path__ + "static/media/temp-persona-5.1ebb1ff9.jpg";